angular.module('graph').controller('ph-notifications', [
    '$scope', '$window', 'ph-core', 'ph-paging', '$rootScope',
    function($scope, $window, $core, $paging, $root) {
        $scope.$paging = $paging.new();

        $scope.query = $core.$uri.$query.new({
            page: 0,
            let: 0
        });

        $scope.loader = -1;

        $scope.$notifications = [];

        $scope.needread = {
            "notification" : 0
        };

        $scope.entry_id = 0;

        $scope.entry = null;

        $scope.$entry = function (name, id) {
            if (name) $scope.entry = name;
            if (id)   $scope.entry_id = id;

            $scope.$on('ph-root-notification-update', function ($e, $entry, $entry_id) {
                if ($entry) $scope.entry = $entry;
                if ($entry_id) $scope.entry_id = $entry_id;

                $scope.init();
            });
        };

        function make(state) {
            if (state === 'entry') {
                var $entry = $scope.entry !== null ? $scope.entry + '/' : '';
                $entry += $scope.entry_id !== 0 ? $scope.entry_id + '/' : '';

                return $entry;
            }
        }

        $scope.init = function ($entry, $entry_id) {
            if ($entry) $scope.entry = $entry;
            if ($entry_id) $scope.entry_id = $entry_id;

            $scope.find();
        };

        $scope.find = function () {
            if ($scope.$paging.pages > -1 && $scope.$paging.pages === $scope.$paging.page)
                return;

            var page = $scope.query.get('page');

            $scope.query.set(
                'page', +(++page)
            );

            $core.get('/xhr/' + make('entry') + 'notifications?' + $scope.query.str())
                .then(function ($response) {
                    if ($response.data.state === 0) {
                        /**
                         *
                         */
                        $scope.$paging.pages = $response.data.pages;

                        /**
                         *
                         */
                        $scope.$paging.page = $response.data.page;

                        /**
                         *
                         */
                        $scope.$notifications = $scope.$notifications.concat(
                            $response.data.data
                        );

                        for(var index = 0; index < $scope.$notifications.length; index++) {
                            var notification = $scope.$notifications[index];

                            if (notification.seen === 0)
                                ++$scope.needread.notification;
                        }
                    }

                    $scope.loader = 0;
                });
        };

        $scope.seen = function ($notification) {
            if ($notification.seen === 0) {
                $core.post('/xhr/' + make('entry') + 'notification/' + $notification.token)
                    .then(function ($response) {
                        if ($response.data.state === 0) {
                            $notification.seen = 1;
                        }
                    });
            }

        };

        $scope.goto = function($notification) {
            $scope.seen($notification);

            $window.location.href = $notification.url;
        }
    }
]).controller('ph-drop-notifications', [
    '$scope', '$controller', 'ph-touch-service',
    function(
        $scope, $controller, $phtouch
    ) {
        angular.extend(this, $controller('ph-notifications', {$scope: $scope}));

        var $module = 'ph-drop-notifications';

        $phtouch.$watch($scope, $module, function() {
            $phtouch.$touch($module, function() {
                $scope.find();
            });
        });
    }
]);
